import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { authApi as legacyAuthApi } from "./authApi";
import { pendingUsersApi } from "./pendingUsersApi";
import { userAccountApi } from "./userAccountApi";
import { statsApi } from "./statsApi";
import { deviceApi } from "./deviceApi";

import { authApi as panelAuthApi } from "../api/authApi";
import { userApi as panelUserApi } from "../api/userApi";
import { dailyLogApi as panelDailyLogApi } from "../api/dailyLogApi";
import { groupsApi as panelGroupsApi } from "../api/groupsApi";
import { managementApi as panelManagementApi } from "../api/managementApi";
import { hatimApi as panelHatimApi } from "../api/hatimApi";
import { hatimManagementApi as panelHatimManagementApi } from "../api/hatimManagementApi";
import { publicStatsApi } from "../api/publicStatsApi";
import { notificationApi } from "../api/notificationApi";
import { muzakereApi } from "../api/muzakereApi";
import { adminApi } from "../api/adminApi";
import { workApi } from "../api/workApi";
import { personalApi } from "../api/personalApi";
import { goalTemplateApi } from "../api/goalTemplateApi";

export const store = configureStore({
  reducer: {
    [legacyAuthApi.reducerPath]: legacyAuthApi.reducer,
    [pendingUsersApi.reducerPath]: pendingUsersApi.reducer,
    [userAccountApi.reducerPath]: userAccountApi.reducer,
    [statsApi.reducerPath]: statsApi.reducer,
    [deviceApi.reducerPath]: deviceApi.reducer,
    [panelAuthApi.reducerPath]: panelAuthApi.reducer,
    [panelUserApi.reducerPath]: panelUserApi.reducer,
    [panelDailyLogApi.reducerPath]: panelDailyLogApi.reducer,
    [panelGroupsApi.reducerPath]: panelGroupsApi.reducer,
    [panelManagementApi.reducerPath]: panelManagementApi.reducer,
    [panelHatimApi.reducerPath]: panelHatimApi.reducer,
    [panelHatimManagementApi.reducerPath]: panelHatimManagementApi.reducer,
    [publicStatsApi.reducerPath]: publicStatsApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [muzakereApi.reducerPath]: muzakereApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [workApi.reducerPath]: workApi.reducer,
    [personalApi.reducerPath]: personalApi.reducer,
    [goalTemplateApi.reducerPath]: goalTemplateApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(legacyAuthApi.middleware)
      .concat(pendingUsersApi.middleware)
      .concat(userAccountApi.middleware)
      .concat(statsApi.middleware)
      .concat(deviceApi.middleware)
      .concat(panelAuthApi.middleware)
      .concat(panelUserApi.middleware)
      .concat(panelDailyLogApi.middleware)
      .concat(panelGroupsApi.middleware)
      .concat(panelManagementApi.middleware)
      .concat(panelHatimApi.middleware)
      .concat(panelHatimManagementApi.middleware)
      .concat(publicStatsApi.middleware)
      .concat(notificationApi.middleware)
      .concat(muzakereApi.middleware)
      .concat(adminApi.middleware)
      .concat(workApi.middleware)
      .concat(personalApi.middleware)
      .concat(goalTemplateApi.middleware),
});

setupListeners(store.dispatch);
